import React, { useEffect, useState } from 'react';
import ReactSlider from 'react-slider';

const valueToColumnCount = (number) => {
  if (number < 3) {
    return number;
  }
  if (number === 3) {
    return 4;
  }

  return number + 2;
};

const columnCountToValue = (columnCount) => {
  if (columnCount <= 2) {
    return columnCount;
  }
  if (columnCount === 4) {
    return 3;
  }

  return columnCount - 2;
};

const Slider = ({ imageColumns, changeImageColumns, enableSingleImageOption }) => {
  const [sliderValue, setSliderValue] = useState(columnCountToValue(imageColumns));

  const handleChange = (value, index) => {
    setSliderValue(value); // Update the slider value
    changeImageColumns(valueToColumnCount(value));
  };

  useEffect(() => {
    if (!enableSingleImageOption && imageColumns === 1) {
      changeImageColumns(valueToColumnCount(2));
    }
  }, [enableSingleImageOption, imageColumns]);

  const renderThumb = (props, state) => {
    return (
      <div {...props}>
        {valueToColumnCount(sliderValue)} {/* Use sliderValue instead of state.value */}
      </div>
    );
  };

  return (
    <ReactSlider
      className="horizontal-slider"
      thumbClassName="example-thumb bg-indigo-950 flex items-center justify-center rounded-lg"
      trackClassName="example-track bg-gray-900"
      marks
      markClassName="example-mark bg-gray-600"
      min={enableSingleImageOption ? 1 : 2}
      max={4}
      step={1}
      value={sliderValue}
      renderThumb={renderThumb}
      onChange={handleChange}
    />
  );
};

export default Slider;
